import React from 'react';
import i18next from 'i18next';
import { useSelector } from 'react-redux';
import { get } from 'lodash-es';
import { Helmet as ReactHelmet } from 'react-helmet';
import { websiteSelector, assetsSelector } from 'common/selectors';

export const Helmet = () => {
  const websiteName = useSelector((state) => get(websiteSelector(state), 'name'));
  const assets = useSelector(assetsSelector);
  const faviconImageUrl = get(assets, 'faviconImage.url', `${window.__MOVINGIMAGE_CT_PUBLIC_URL}/static/movingimage-favicon.ico`);
  const faviconType = faviconImageUrl.includes('.png') ? 'image/png' : 'image/x-icon';

  return (
    <ReactHelmet htmlAttributes={{ lang : i18next.language, dir: i18next.dir() }}>
      <title>{websiteName}</title>
      <link rel="shortcut icon" href={faviconImageUrl} type={faviconType} />
      <link rel="apple-touch-icon" href={faviconImageUrl} type={faviconType} />
    </ReactHelmet>
  );
};
